<div class="tour-hotspot-container">
  <div
    class="tour-hotspot"
    (click)="dismiss()"
    [rcpPopover]="content"
    [rcpPopoverPlacement]="position"
    [rcpPopoverVariation]="variation"
  ></div>

  <!-- we need reference the content by template-->
  <ng-template #content>
    <ng-content></ng-content>
  </ng-template>
</div>
